import React, { useContext, useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { UserRegistration } from "./UserRegister";
import { UserList } from "./UserList";
import { CardsNFCTabs } from "../WalletAdminTabs/CardsNFCTabs";
import { StockTabs } from "../WalletAdminTabs/StockTabs";
import { ReportsTabs } from "../WalletAdminTabs/ReportsTabs";
import { MenuPermissionsPanel } from "./MenuPermissionsPanel";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { staffCanAccessMenu } from "../../config/menuAccessCatalog";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`config-tabpanel-${index}`}
      aria-labelledby={`config-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `config-tab-${index}`,
    "aria-controls": `config-tabpanel-${index}`,
  };
}

export function ConfigTabs() {
  const isMobile = window.innerWidth <= 600;
  const auth = useContext(AuthContext);
  const user = auth.user;

  const tabDefs = useMemo(
    () => [
      { menu: "config_user_register", label: "Cadastrar Usuário", panel: <UserRegistration /> },
      { menu: "config_user_list", label: "Lista de Usuários", panel: <UserList /> },
      { menu: "config_nfc", label: "Cartões NFC", panel: <CardsNFCTabs /> },
      { menu: "config_stock", label: "Estoque", panel: <StockTabs /> },
      { menu: "config_reports", label: "Relatórios", panel: <ReportsTabs /> },
      {
        menu: "config_menu_permissions",
        label: "Permissões de menu",
        panel: <MenuPermissionsPanel />,
        adminOnly: true,
      },
    ],
    []
  );

  const visibleTabs = useMemo(
    () =>
      tabDefs.filter((t) => {
        if (t.adminOnly) return user?.level === "admin";
        return staffCanAccessMenu(user, t.menu);
      }),
    [tabDefs, user]
  );

  const [value, setValue] = useState(0);

  useEffect(() => {
    setValue((v) => (visibleTabs.length && v >= visibleTabs.length ? 0 : v));
  }, [visibleTabs.length]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if (!visibleTabs.length) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography variant="body1" color="text.secondary">
          Nenhuma aba de configuração disponível para o seu usuário.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Configurações"
          variant={isMobile ? "scrollable" : "standard"}
          scrollButtons={isMobile ? "auto" : false}
          allowScrollButtonsMobile={isMobile}
          centered
        >
          {visibleTabs.map((t, index) => (
            <Tab key={t.menu} label={t.label} {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>
      {visibleTabs.map((t, index) => (
        <TabPanel key={t.menu} value={value} index={index}>
          {t.panel}
        </TabPanel>
      ))}
    </Box>
  );
}
